

import { LucideIcon, Check, Key, Shield, Users, RefreshCw, Settings, CheckCircle, Zap, Database, Lock, Globe, Workflow, Blocks, Puzzle, Link, Network, BarChart3, LineChart, Bot, Wrench, MessageSquare, Clock, Eye, AlertTriangle, FileCheck, Router, DollarSign, Server, Code, MapPin, Mail, Phone, MousePointer, GitBranch, TrendingDown, TrendingUp, Brain, BrainCircuit, GraduationCap, Heart, Laptop, Rocket, Building2, FileText, Webhook } from "lucide-react"

const iconMap: Record<string, LucideIcon> = {
  Key,
  Shield,
  Users,
  RefreshCw,
  Settings,
  CheckCircle,
  Zap,
  Database,
  Lock,
  Globe,
  Workflow,
  Blocks,
  Puzzle,
  Link,
  Network,
  BarChart3,
  LineChart,
  Bot,
  Wrench,
  MessageSquare,
  Clock,
  Eye,
  AlertTriangle,
  FileCheck,
  Router,
  DollarSign,
  Server,
  Code,
  MapPin,
  Mail,
  Phone,
  MousePointer,
  GitBranch,
  TrendingDown,
  TrendingUp,
  Brain,
  BrainCircuit,
  GraduationCap,
  Heart,
  Laptop,
  Rocket,
  Building2,
  FileText,
  Webhook,
}

interface Feature {
  title: string
  description: string
  icon?: LucideIcon
  iconName?: string
}

interface FeatureShowcaseProps {
  features: Feature[]
  columns?: 2 | 3 | 4
  variant?: "cards" | "list" | "icons"
}

export function FeatureShowcase({
  features,
  columns = 3,
  variant = "cards"
}: FeatureShowcaseProps) {
  const gridCols = {
    2: "sm:grid-cols-2",
    3: "sm:grid-cols-2 lg:grid-cols-3",
    4: "sm:grid-cols-2 lg:grid-cols-4"
  }[columns]

  if (variant === "list") {
    return (
      <div className="space-y-4">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-1">
              <Check className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h3 className="font-semibold">{feature.title}</h3>
              <p className="text-sm text-muted-foreground mt-1">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (variant === "icons") {
    return (
      <div className={`grid grid-cols-1 gap-8 ${gridCols}`}>
        {features.map((feature, index) => {
          const Icon = feature.icon || (feature.iconName ? iconMap[feature.iconName] : undefined)
          return (
            <div key={index} className="text-center">
              {Icon && (
                <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
                  <Icon className="h-7 w-7 text-primary" />
                </div>
              )}
              <h3 className="mt-4 font-semibold">{feature.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{feature.description}</p>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className={`grid grid-cols-1 gap-6 ${gridCols}`}>
      {features.map((feature, index) => {
        const Icon = feature.icon || (feature.iconName ? iconMap[feature.iconName] : undefined)
        return (
          <div
            key={index}
            className="rounded-xl border bg-card p-6 transition-all hover:shadow-md"
          >
            {Icon && (
              <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
                <Icon className="h-5 w-5 text-primary" />
              </div>
            )}
            <h3 className="mt-4 font-semibold">{feature.title}</h3>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
              {feature.description}
            </p>
          </div>
        )
      })}
    </div>
  )
}
